import React, { useEffect, useState } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import apiConfig from "../apiConfig";

const PromotionEdit = () => {
  const { id } = useParams();
  const history = useHistory();

  const [inpval, setINP] = useState({
    promotionName: "",
    promotionType: "",
    bonusAmount: "",
    bonusType: "fixed",
    bonusCategory: "",
    bannerImage: "",
    turnover: "",
    startTime: "",
    endTime: "",
    status: "Active",
  });

  const [loading, setLoading] = useState(false);
  const [bannerFile, setBannerFile] = useState(null);

  // fetch existing promotion data
  const fetchPromotion = async () => {
    try {
      const res = await axios.get(`${apiConfig.baseURL}/api/admin/getPromotionData/${id}`);
      const data = res.data;
      setINP({
        promotionName: data.promotionName || "",
        promotionType: data.promotionType || "",
        bonusAmount: data.bonusAmount || "",
        bonusType: data.bonusType || "fixed",
        bonusCategory: data.bonusCategory || "",
        bannerImage: data.bannerImage || "",
        turnover: data.turnover || "",
        startTime: data.startTime ? data.startTime.slice(0, 16) : "",
        endTime: data.endTime ? data.endTime.slice(0, 16) : "",
        status: data.status || "Active",
      });
    } catch (err) {
      console.error(err);
      alert("Failed to fetch promotion data");
    }
  };

  useEffect(() => {
    fetchPromotion();
  }, [id]);

  const setdata = (e) => {
    const { name, value, files } = e.target;
    if (name === "bannerImage" && files.length > 0) {
      setBannerFile(files[0]);
    } else {
      setINP((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      Object.keys(inpval).forEach((key) => {
        formData.append(key, inpval[key]);
      });
      if (bannerFile) formData.append("bannerImage", bannerFile);

      await axios.put(`${apiConfig.baseURL}/api/admin/updatePromotion/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("✅ Promotion updated successfully!");
      history.push("/promo-code-list");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to update promotion.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-8 offset-lg-2">
            <div className="card">
              <div className="card-header">
                <h4>Edit Promotion</h4>
              </div>
              <div className="card-body">
                <div className="basic-form">
                  <form onSubmit={handleUpdate}>
                    {/* Promotion Name */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Promotion Name</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          name="promotionName"
                          className="form-control"
                          value={inpval.promotionName}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Promotion Type */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Promotion Type</label>
                      <div className="col-sm-9">
                        <select
                          name="promotionType"
                          className="form-control"
                          value={inpval.promotionType}
                          onChange={setdata}
                        >
                          <option value="">Select Type</option>
                          <option value="First Signup">First Signup</option>
                          <option value="Deposit Bonus">Deposit Bonus</option>
                          <option value="Cashback">Cashback</option>
                          <option value="Referral">Referral</option>
                          <option value="Special Day Offer">Special Day Offer</option>
                          <option value="offer">Offer</option>
                        </select>
                      </div>
                    </div>

                    {/* Bonus Amount + Type */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Bonus</label>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="bonusAmount"
                          className="form-control"
                          value={inpval.bonusAmount}
                          onChange={setdata}
                        />
                      </div>
                      <div className="col-sm-3">
                        <select
                          name="bonusType"
                          className="form-control"
                          value={inpval.bonusType}
                          onChange={setdata}
                        >
                          <option value="fixed">Fixed</option>
                          <option value="percentage">Percentage</option>
                        </select>
                      </div>
                    </div>

                    {/* Bonus Category */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Bonus Category</label>
                      <div className="col-sm-9">
                        <select
                          name="bonusCategory"
                          className="form-control"
                          value={inpval.bonusCategory}
                          onChange={setdata}
                        >
                          <option value="">Select Category</option>
                          <option value="One Time">One Time</option>
                          <option value="All Time">All Time</option>
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Yearly">Yearly</option>
                        </select>
                      </div>
                    </div>

                    {/* Banner Image */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Banner Image</label>
                      <div className="col-sm-9">
                        {inpval.bannerImage && (
                          <div className="mb-2">
                            <img
                              src={`${apiConfig.baseURL}/images/${inpval.bannerImage}`}
                              alt="Banner"
                              style={{ width: "200px", borderRadius: "8px", border: "1px solid #ccc" }}
                            />
                          </div>
                        )}
                        <input
                          type="file"
                          name="bannerImage"
                          className="form-control"
                          accept="image/*"
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Turnover */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Turnover</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          name="turnover"
                          className="form-control"
                          value={inpval.turnover}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Start Time */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Start Time</label>
                      <div className="col-sm-9">
                        <input
                          type="datetime-local"
                          name="startTime"
                          className="form-control"
                          value={inpval.startTime}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* End Time */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">End Time</label>
                      <div className="col-sm-9">
                        <input
                          type="datetime-local"
                          name="endTime"
                          className="form-control"
                          value={inpval.endTime}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Submit */}
                    <div className="mb-3 row" align="right">
                      <div className="col-sm-10">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                          {loading ? "Updating..." : "Update Promotion"}
                        </button>
                        <Link to="/promo-code-list" className="btn btn-secondary ms-2">
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PromotionEdit;
